import { render, staticRenderFns } from "./BallAnimation.vue?vue&type=template&id=eaf643d6&"
import script from "./BallAnimation.vue?vue&type=script&lang=js&"
export * from "./BallAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports